<!-- <div *ngIf="hasUserAccess$ | async">
    <router-outlet></router-outlet>
</div> -->
<div style="min-height:70vh">
    <router-outlet></router-outlet>
</div>
